var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "diglog-card",
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t("components.tips"),
        width: "410px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: function ($event) {
          return _vm.$emit("closeModal")
        },
      },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", [
          _c("i", { staticClass: "icon-submit" }),
          _c("span", { staticClass: "submit-text" }, [
            _vm._v(_vm._s(_vm.$t("data.successfully_submit"))),
          ]),
        ]),
        _c("p", { staticClass: "amount-text" }, [
          _vm._v(_vm._s(_vm.$t("data.top_up_amount")) + "："),
          _c("span", { staticStyle: { color: "#488CE8" } }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(_vm._f("numWithDot")(_vm.amount))
            ),
          ]),
        ]),
        _c("div", { staticClass: "line" }),
        _c("p", { staticClass: "tip" }, [
          _vm._v(_vm._s(_vm.$t("data.recharge_success_tip"))),
        ]),
        _c(
          "div",
          {
            staticClass: "dialog-footer",
            staticStyle: { width: "100%" },
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-back",
                attrs: { type: "info" },
                on: {
                  click: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("components.close")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }